import { Join } from 'design-studio/lib'

interface DiagramCostOfInferenceProps {
  className?: string
  blueClassName?: string
  axisTitleClassName?: string
}

export function DiagramCostOfInference({
  className,
  blueClassName = 'text-blue-500 dark:text-blue-300',
  axisTitleClassName = 'text-slate-500 dark:text-slate-300',
}: DiagramCostOfInferenceProps) {
  return (
    <svg
      viewBox="0 0 560 315"
      className={Join('h-auto w-full', className)}
      fill="none"
      aria-label="Chart: Cost of inference vs Software complexity"
    >
      <defs>
        {/* Stroke gradient: orange → red (LLM-only curve) */}
        <linearGradient
          id="ciLineGrad"
          x1="78"
          y1="256"
          x2="524"
          y2="33"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0%" stopColor="#f97316" />
          <stop offset="100%" stopColor="#dc2626" />
        </linearGradient>
        {/* Area fills: fade to transparent toward baseline */}
        <linearGradient
          id="ciOrangeFill"
          x1="0"
          y1="33"
          x2="0"
          y2="262"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0%" stopColor="#f97316" stopOpacity="0.13" />
          <stop offset="100%" stopColor="#f97316" stopOpacity="0.02" />
        </linearGradient>
        <linearGradient
          id="ciBlueFill"
          x1="0"
          y1="198"
          x2="0"
          y2="262"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0%" stopColor="#3b82f6" stopOpacity="0.12" />
          <stop offset="100%" stopColor="#3b82f6" stopOpacity="0.02" />
        </linearGradient>
        <marker
          id="ciArrow"
          markerWidth="6"
          markerHeight="5"
          refX="5"
          refY="2.5"
          orient="auto"
          markerUnits="userSpaceOnUse"
        >
          <polygon points="0 0, 6 2.5, 0 5" fill="#94a3b8" />
        </marker>
      </defs>

      {/* Dashed horizontal grid */}
      {[106, 145, 184].map((y) => (
        <line
          key={y}
          x1="78"
          y1={y}
          x2="526"
          y2={y}
          stroke="#94a3b8"
          strokeWidth="0.6"
          strokeOpacity="0.25"
          strokeDasharray="4 5"
        />
      ))}

      {/* Axes */}
      <line
        x1="78"
        y1="262"
        x2="78"
        y2="18"
        stroke="#94a3b8"
        strokeWidth="1.5"
        markerEnd="url(#ciArrow)"
      />
      <line
        x1="78"
        y1="262"
        x2="548"
        y2="262"
        stroke="#94a3b8"
        strokeWidth="1.5"
        markerEnd="url(#ciArrow)"
      />

      {/* Y axis label */}
      <g transform="translate(22,145) rotate(-90)">
        <text
          textAnchor="middle"
          className={axisTitleClassName}
          fill="currentColor"
          fontSize="13"
          fontFamily="system-ui,sans-serif"
        >
          Cost of inference
        </text>
      </g>

      {/* X axis label */}
      <text
        x="304"
        y="305"
        textAnchor="middle"
        className={axisTitleClassName}
        fill="currentColor"
        fontSize="13"
        fontFamily="system-ui,sans-serif"
      >
        Software complexity
      </text>

      {/* Area fills (drawn before curves so curves sit on top) */}
      <path
        d="M 78 256 C 175 252 285 224 355 170 C 415 120 462 68 524 33 L 524 262 L 78 262 Z"
        fill="url(#ciOrangeFill)"
      />
      <path
        d="M 78 242 C 200 238 385 229 524 198 L 524 262 L 78 262 Z"
        fill="url(#ciBlueFill)"
      />

      {/* LLM + SpecLogician — gentle rise */}
      <path
        d="M 78 242 C 200 238 385 229 524 198"
        className={blueClassName}
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />

      {/* LLM-only — exponential rise */}
      <path
        d="M 78 256 C 175 252 285 224 355 170 C 415 120 462 68 524 33"
        stroke="url(#ciLineGrad)"
        strokeWidth="2"
        strokeLinecap="round"
      />

      {/* Curve labels */}
      <text
        x="366"
        y="88"
        fill="#ea580c"
        fontSize="11"
        fontFamily="system-ui,sans-serif"
      >
        LLM-only
      </text>
      <text
        x="345"
        y="215"
        className={blueClassName}
        fill="currentColor"
        fontSize="11"
        fontFamily="system-ui,sans-serif"
      >
        LLM + SpecLogician
      </text>
    </svg>
  )
}
